import React, { useEffect, useState } from "react";
import {
  Dropdown,
  Input,
  RadioGroup,
  Radio,
  Option,
  Combobox,
} from "@fluentui/react-components";
import SearchResourceInGraph from "./SearchResourceInGraph";
import { useTranslation } from "react-i18next";
export default function Fallback(props) {
  const { t } = useTranslation();
  const inputItems = ["phone", "user", "voicemail"];
 
  const [queues, setQueues] = useState([]);
  const [query, setQuery] = useState(props.valueName);

  // Mettre à jour query quand valueName change (ex: après refresh)
  useEffect(() => {
    if (props.valueName) {
      setQuery(props.valueName);
    }
  }, [props.valueName]);

  // Préparation des queues (formatage nom + id)
  useEffect(() => {
    if (props.QUEUES) {
      // Convert object to array of its values
      const extractedQueues = Array.isArray(props.QUEUES)
        ? props.QUEUES.flatMap((obj) => Object.values(obj || {}))
        : Object.values(props.QUEUES); // ✅ handle object form
  
      // Map to uniform structure
      const formatted = extractedQueues.map((q) => ({
        key: q.id,
        value: q.id,
        queueName: q.queueName,
      }));
  
      setQueues(formatted);
    }
  }, [props.QUEUES]);
  
  const filteredOptions = queues
    .filter((q) => q.queueName?.toLowerCase().includes(query.toLowerCase()))
    .map((q) => (
      <Option key={q.key} value={q.value}>
        {q.queueName}
      </Option>
    ));
  return (
    <div>
      <RadioGroup
        className="radio-group-style "
        layout="horizontal"
        value={props.typeValue}
        disabled={props.disabled}
        onChange={(_, data) => {
          props.setFallBackType(data.value);
        }}
      >
        <Radio value="disconnect" label={t("DISCONNECT")} />
        <Radio value="transfer" label={t("TRANSFER_TO")} />
        <Radio value="queue" label={t("QUEUE")} />
      </RadioGroup>
      {props.typeValue === "transfer" && (
        <>
          <Dropdown
            clearable
            className="dropdown-inline"
            placeholder={t("SELECT_SCOPE")}
            value={props.valueTargetType}
            disabled={props.disabled}
            onOptionSelect={(_, data) => {
              props.updateTargetType(_,data);
            }}
          >
            {inputItems.map((item, index) => (
              <Option key={index} value={item}>
                {item}
              </Option>
            ))}
          </Dropdown>
          {props.valueTargetType === "phone" && (
            <div >
              <Input
                clearable
                className="dropdown-inline phone-number-input"
                value={props.targetId}
                disabled={props.disabled}
                onChange={(event, data) => {
                  props.updateTargetId(event, data);
                }}
              />
            </div>
          )}
          {(props.valueTargetType === "user" ||
            props.valueTargetType === "voicemail") && (
            <div className="search-user-queue-style">
              <SearchResourceInGraph
                displayName={props.displayName}
                onSelectUser={(user) => {
                  props.searchUser(user);
                }}
                isUpdate={props.isUpdate}
                disabled={props.disabled}
              />
            </div>
          )}
        </>
      )}
      {props.typeValue === "queue" && (
        <Combobox
          className="dropdown-inline"
          placeholder={t("SEARCH_QUEUE")}
          value={query}
          disabled={props.disabled}
          onChange={(e) => setQuery(e.target.value)}
          onOptionSelect={(_, data) => {
            const selectedQueue = queues.find(
              (q) => q.value === data.optionValue
            );
            if (selectedQueue) {
              props.onQueueSelect(selectedQueue);
              setQuery(selectedQueue.queueName);
            }
          }}
        >
          {filteredOptions}
        </Combobox>
      )}
    </div>
  );
}
